import { CardHeader } from "reactstrap";
import styled from "styled-components"


export const StyledCardHeader = styled(CardHeader).attrs(() => ({
    className: "text-white bg-header",
}))`
font-family: "baloo";
font-size: 1.3em;`;



export const StyledButton = styled.button.attrs(() => ({
    className: "bg-header hover:bg-header border-0  text-white px-6 py-2 rounded-md w-full",
}))`color:"white";`;